<template>
  <PersonalTasks v-if="isPersonalOrganization" />
  <TeamTasks v-else :org-id="orgId" />
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import * as inject from "@/components/inject";
import PersonalTasks from "@/components/tasks/PersonalTasks.vue";
import TeamTasks from "@/components/tasks/TeamTasks.vue";

export default defineComponent({
  name: "Tasks",
  components: {
    PersonalTasks,
    TeamTasks,
  },
  props: {
    orgId: { type: String, required: true },
  },
  setup(props) {
    const profile = inject.profile();
    const isPersonalOrganization = computed(
      () => props.orgId === profile.value.user.personal.organizationId
    );

    return {
      isPersonalOrganization,
    };
  },
});
</script>
